import { SiteMapPageContent } from './shipsticks.page.content'

const sections = [
  {
    title: 'Our Service',
    links: [
      { name: 'Create Account', href: '/book' },
      { name: 'Login', href: '/book/login' },
      { name: 'Ship', href: '/book/ship' },
      { name: 'Tracking', href: '/order-tracking' },
      { name: 'Drop Off Locator', href: '/drop-off-locator' },
    ],
  },
  {
    title: 'Learn More',
    links: [
      { name: 'How It Works', href: '/how-it-works' },
      { name: 'Reviews', href: '/reviews' },
      { name: 'FAQ', href: '/faq' },
      { name: 'Partners', href: '/partnership-benefits' },
      { name: 'Airline Baggage Fees', href: 'https://www.shipskis.com/airline-baggage-fees' },
    ],
  },
  {
    title: 'News',
    links: [
      { name: 'Blog', href: 'https://www.shipskis.com/blog/' },
      { name: 'Winter Gear', href: 'https://www.shipskis.com/blog/gear/' },
      { name: 'Ski & Snowboard Tips', href: 'https://www.shipskis.com/blog/tips/' },
      { name: 'Travel Tips', href: 'https://www.shipskis.com/blog/tips/travel-tips/' },
      { name: 'Ski & Snowboard Destinations', href: 'https://www.shipskis.com/blog/travel/' },
      { name: 'Ski & Snowboard News', href: 'https://www.shipskis.com/blog/news/' },
    ],
  },
  {
    title: 'Help',
    links: [
      { name: 'Support Center', href: 'https://support.shipskis.com/hc/en-us' },
      { name: 'File a claim', href: '/claims' },
      { name: 'Contact', href: '/contact' },
    ],
  },
  {
    title: 'Company',
    links: [
      { name: 'About Us', href: '/about' },
      { name: 'Careers', href: '/careers' },
    ],
  },
  {
    title: 'Our Brands',
    links: [
      { name: 'Ship Play', href: 'https://www.shipplay.com/' },
      { name: 'Ship Sticks', href: 'https://www.shipsticks.com/' },
      { name: 'Ship Skis', href: 'https://www.shipskis.com/' },
      { name: 'Ship Camps', href: 'https://www.shipcamps.com/' },
      { name: 'Luggage Free', href: 'https://www.luggagefree.com/' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { name: 'Privacy Policy', href: '/privacy' },
      { name: 'Terms of Use', href: '/terms' },
    ],
  },
]

const content: SiteMapPageContent = {
  sections,
}

export default content
